import React, { useEffect } from 'react'
import { ASR_EVENTS } from '../StudentASRConstants'
import useStudentPreChecks from '../../useStudentPreChecks'
import StudentInstruction from '../../Components/StudentInstruction'
import { PRE_CHECK_MACHINE_STATES } from '../../constants'

export default React.memo(function TeacherTestResultFailed({ teacherRetry, hasHighBackgroundNoise }) {

    const studentPreCheck = useStudentPreChecks({ itemToCheck: PRE_CHECK_MACHINE_STATES.studentASRChecks })

    useEffect(() => {
        if (hasHighBackgroundNoise) {
            studentPreCheck.logEvent(ASR_EVENTS.TEACHER_TEST_FAILED_WITH_BG_NOISE)
        } else {
            studentPreCheck.logEvent(ASR_EVENTS.TEACHER_TEST_FAILED_WITHOUT_BG_NOISE)
        }
        studentPreCheck.logEvent(ASR_EVENTS.TEACHER_TEST_FAILED)
    }, [])

    return <StudentInstruction>
        <p>See this <a target="_blank" href="https://support.amiralearning.com/s/article/What-do-I-do-if-Amira-cannot-hear-a-student">help link</a> for troubleshooting steps or contact support@amiralearning.com for assistance. Error code 1235.</p>
        {teacherRetry && <button onClick={teacherRetry}>Test again</button>}
    </StudentInstruction>

})
